import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router'
import './styles/index.css'
import './stores/theme'
import { router } from './router'
import { useAuthStore } from './stores/auth'
import { rememberOpenedFromApp } from './utils/appDownloadPrompt'

/**
 * Collapse images that fail to load, app-wide. `error` does not bubble but
 * does fire in the capture phase on document, so one listener covers every
 * image, including ones added later. Containers keep their own fallback.
 */
document.addEventListener(
  'error',
  (event) => {
    const el = event.target as HTMLElement | null
    if (el?.tagName !== 'IMG' || el.dataset.brokenHandled) return
    el.dataset.brokenHandled = '1'
    el.style.display = 'none'
    el.closest('[data-img-container]')?.setAttribute('data-img-broken', '')
  },
  true
)

// Before the router can redirect away from a Stripe return URL
rememberOpenedFromApp()

useAuthStore.getState().initAuth().catch((error: unknown) => {
  console.error('Auth initialization failed:', error)
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
)
